

import React from 'react';
import ServiceForm from '../components/ServiceForm';
import { CodeHighlighter } from '../components/CodeHighlighter';


const matchSetPlayersEndpoint = "season/%sid/match/%nid/set-players";
const matchSetPlayersArguments = []

const matchSetPlayersUrlArguments = [
  { name: 'sid', type: 'numeric',  mandatory: true, default: '', description: 'Season ID'},
  { name: 'nid', type: 'numeric',  mandatory: true, default: '', description: 'Match ID'},
]

const matchSetPlayersSample = [
  {
    "player": "2853",
    "number": 1
  },
  {
    "player": "2855",
    "number": 2,
    "vice_captain": true
  },
  {
    "player": "2856",
    "number": 3,
    "captain": true
  },
  {
    "player": "2857",
    "number": 4,
    
  },
  {
    "player": "2854",
    "number": 5
  },
  {
    "player": "2859",
    "number": 6
  },
  {
    "player": "2860",
    "number": 7
  },
  {
    "player": "2861",
    "number": 8
  }
]


export function MatchSetPlayers() {
  return <MatchSetPlayersComponent/>;
}


class MatchSetPlayersComponent extends React.Component {

  render() {

        return (
            <div>
                  <h3>List the Match players (formation)</h3>

                  <p>Endpoint: <b>{matchSetPlayersEndpoint}</b></p>

                  <p>
                    This service can be used to set the list of players of the match and set capitan and vice-capitan<br/>
                    <br/>
                  </p>
                  
                  <ServiceForm
                        args={matchSetPlayersArguments}
                        urlArgs={matchSetPlayersUrlArguments}
                        sample={matchSetPlayersSample}
                        endpoint={matchSetPlayersEndpoint}
                        authRequired={true}
                        usePayload={true}
                  />

                  <h4>Request</h4>
                  <p>
                  The formation in JSON format as list of objects with the fields <i>player</i> (pid of the player), <i>number</i> and optionally the field <i>vice_captain</i> and <i>captain</i>.
                  </p>
<CodeHighlighter code={
  [{
    "player": "2861",
    "number": 8,
    "vice_captain": true
  }]} />
                  
                  <h4>Response</h4>
                  <p>
                   The modified list
                  </p>
                  
            </div>
        );
  }


} 